module.exports = __webpack_public_path__ + "img/logo.de7f79a1.png";